.langRow {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.langLink {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--tdx-navy);
  text-decoration: none;
}

.langLink:hover {
  text-decoration: underline;
}

/* globe icon */
.langLink::before {
  content: '';
  width: 1.15em;
  height: 1.15em;
  background: url('/images/ico-world.svg') no-repeat center / contain;
}
